import { apiClient, fastApiClient } from "../App";

// Get Template Library (supports search, status, category, channel, difficulty filters)
export const getTemplateLibrary = (params = {}) => {
  return fastApiClient.get("/template-library", { params });
};

// Get single Template Library item (detail)
export const getTemplateLibraryDetail = (templateId) => {
  return fastApiClient.get(`/template-library/${templateId}`);
};

// Create a new Template Library item
export const createTemplateLibrary = (data) => {
  return fastApiClient.post("/template-library", data);
};

// Update an existing Template Library item
export const updateTemplateLibrary = (templateId, data) => {
  return fastApiClient.put(`/template-library/${templateId}`, data);
};

// Delete a Template Library item
export const deleteTemplateLibrary = (templateId) => {
  return fastApiClient.delete(`/template-library/${templateId}`);
};

// Add / replace a CID (embedded) image on a library template
// export const addLibraryCidImage = (templateId, formData) => {
//   return fastApiClient.post(`/template-library/${templateId}/add-cid-image`, formData);
// };

// Remove a CID image from a library template
// export const removeLibraryCidImage = (templateId, cid) => {
//   return fastApiClient.delete(`/template-library/${templateId}/cid-image/${cid}`);
// };

// Add a decoy attachment to a library template
// export const addLibraryAttachment = (templateId, formData) => {
//   return fastApiClient.post(`/template-library/${templateId}/add-attachment`, formData);
// };

// Remove a decoy attachment from a library template
// export const removeLibraryAttachment = (templateId, attachmentId) => {
//   return fastApiClient.delete(`/template-library/${templateId}/attachment/${attachmentId}`);
// };

// Clone Template (library -> user's email templates)
export const cloneTemplate = (templateId) => {
  return fastApiClient.post(`/template-library/${templateId}/clone-to-email-template`);
};

export const syncInteraktTemplates = () => {
  return fastApiClient.post("/interakt_templates_sync");
};